import PropTypes from 'prop-types';
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  List,
  ListItemText,
  ListItem,
} from '@material-ui/core';

function TeamList(props) {
  const {teams, onSelectTeam} = props;
  const teamListItems = teams.map((team) => (
    <ListItem button key={team.id} onClick={() => onSelectTeam(team)}>
      <Avatar>{team.name.substring(0, 1).toUpperCase()}</Avatar>
      <ListItemText style={{marginLeft: 10}} primary={team.name} />
    </ListItem>
  ));

  return (
    <Card>
      <CardHeader title="add: Team" />
      <CardContent>
        <List style={{maxWidth: 360}}>{teamListItems}</List>
      </CardContent>
    </Card>
  );
}

TeamList.propTypes = {
  teams: PropTypes.array.isRequired,
  onSelectTeam: PropTypes.func.isRequired,
};

export default TeamList;
